import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WindowShopManagerNutritionTableModule } from 'src/app/shared/components/window-shop-manager-nutrition-table/window-shop-manager-nutrition-table.module';
import { PriceTableModule } from 'src/app/shared/components/price-table/price-table.module';
import { CarouselSwiperModule } from 'src/app/shared/components/carousel-swiper/carousel-swiper.module';
import { WindowShopManagerHeaderModule } from 'src/app/shared/components/window-shop-manager-header/window-shop-manager-header.module';
import { PaymentMethodsModule } from 'src/app/shared/components/payment-methods/payment-methods.module';
import { MatDividerModule } from '@angular/material/divider';
import { ProductSelectorModule } from 'src/app/shared/components/product-selector/product-selector.module';
import { DescomplicaShopWindowComponent } from './descomplica-shop-window.component';
import { ProductDescomlicaModule } from "../../../shared/components/product-descomplica/product-descomplica.modules";
import { ComparativeSdsnModule } from 'src/app/shared/components/comparative-sdsn/comparative-sdsn.module';


@NgModule({
  declarations: [
    DescomplicaShopWindowComponent
  ],
  imports: [
    CommonModule,
    WindowShopManagerHeaderModule,
    WindowShopManagerNutritionTableModule,
    PriceTableModule,
    CarouselSwiperModule,
    
    PaymentMethodsModule,
    MatDividerModule,
    ProductSelectorModule,
    ProductDescomlicaModule,
    ComparativeSdsnModule
],
  exports:[
    DescomplicaShopWindowComponent
  ]
})
export class DescomplicaShopWindowModule { }